/**
 * @typedef {import('vue').ComponentOptions<Vue>} VueComponent
 */

/** @type {VueComponent} */

import Vue from 'vue';

export default {
    props: {
        content: {
            type: Array,
        },
        selectedModelVersion: {
            type: String,
        },
        urlMappings: {
            type: Object,
        },
    },

    data() {
        return {
            modelVersion: this.selectedModelVersion,
            selectedContentForModelSwitcher: null,
        };
    },

    mounted() {
        this.handleSetSelectedContentByModelVersion(this.modelVersion);
    },

    watch: {
        modelVersion: function (newVersionHandle) {
            this.handleSetSelectedContentByModelVersion(newVersionHandle);
        },
        selectedModelVersion: function (newVersionHandle) {
            this.modelVersion = newVersionHandle;
        },
    },

    methods: {
        slugifyModelVersionName(modelVersionName) {
            return modelVersionName.replace(/\s+/g, '-').toLowerCase();
        },

        handleSetSelectedContentByModelVersion(versionHandle) {
            this.selectedContentForModelSwitcher = this.content.find(
                (switcher) => switcher.modelVersionHandle === versionHandle,
            );
        },

        getUrlForModelVersion(versionHandle) {
            if (this.isCurrentModel(versionHandle)) {
                return '';
            }

            return this.urlMappings[versionHandle] || '';
        },

        isCurrentModel(modelVersionHandle) {
            return this.selectedModelVersion === modelVersionHandle;
        },

        handleModelLinkClick(modelVersionHandle, event) {
            if (!this.isCurrentModel(modelVersionHandle)) return;

            event.preventDefault();
        },
    },
};
